import template from './ffn-management.html';

const DIRECTIVE_NAME = FfnManagement.DIRECTIVE_NAME = 'ktFfnManagement';
export default function FfnManagement() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FfnManagementController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            enabled: `=${DIRECTIVE_NAME}Enabled`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function FfnManagementController(
    ffnManagementService,
    l10nService
) {
    'ngInject';
    const vm = this;
    const MAX_LENGTH = 10;

    Object.assign(vm, {
        editedItem: {},
        $onInit,
        isAddDisabled,
        addFFNClick,
        addFFN,
        removeFFNClick,
        removeFFN,
        getTooltip,
    });

    function $onInit() {
        vm.model = vm.model || [];
        ffnManagementService.getAirlines()
            .then((airlines) => {
            vm.airlines = airlines;
        });
        vm.allianceHint = l10nService.localize('The airline which issued the FFN');
    }

    function checkMaximumFFNCount() {
        vm.maxFFNCount = vm.model.length === MAX_LENGTH;
    }
    function isAddDisabled() {
        return !vm.editedItem.number || !vm.editedItem.supplier;
    }

    function addFFNClick() {
        if (!vm.editedItem.supplier) {
            return;
        }
        vm.model = vm.model || [];
        vm.addFFNForm.$submitted = !vm.addFFNForm.$valid;
        checkMaximumFFNCount();
        if (!vm.maxFFNCount && !isAddDisabled() && vm.addFFNForm.$valid) {
            addFFN();
        }
    }

    function getTooltip() {
        return l10nService.localize('Airline and FFN fields should be filled');
    }

    function addFFN() {
        const {supplier, number} = vm.editedItem;
        vm.model.changed = true;
        vm.model.push({
            SupplierCode: supplier.value,
            SupplierName: supplier.text,
            Ffn: number});
        vm.editedItem = {};
    }

    function removeFFNClick(index) {
        const clubCard = vm.model[index];
        ffnManagementService.removeConfirmation(clubCard, vm.selectedSeats)
            .then(() => vm.removeFFN(index));
    }

    function removeFFN(index) {
        vm.model.changed = true;
        vm.model.splice(index, 1);
        checkMaximumFFNCount();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/ffn-management/ffn-management-component.js